/*
 * @Author: dengjiayao
 * @Date:   2019-07-09 14:57:07
 * @Last Modified by:   dengjiayao
 * @Last Modified time: 2019-07-09 14:57:45
 */

function checkType(obj, typeName) {
  return Object.prototype.toString.call(obj).toLowerCase() === `[object ${typeName.toLowerCase()}]`
}

// 字符串的下划线格式转驼峰格式，eg：hello_world => helloWorld
function underline2Hump(s) {
  return s.replace(/_(\w)/g, (all, letter) => letter.toUpperCase())
}

// 字符串的驼峰格式转下划线格式，eg：helloWorld => hello_world
function hump2Underline(s) {
  return s.replace(/([A-Z])/g, '_$1').toLowerCase()
}

function deepClone(clone, changeName) {
  const ret = checkType(clone, 'array') ? [] : {}
  for (let key in clone) {
    const copy = clone[key]
    if (changeName) {
      key = changeName(key)
    }
    if (checkType(copy, 'object') || checkType(copy, 'array')) {
      ret[key] = deepClone(copy, changeName)
    } else {
      ret[key] = copy
    }
  }
  return ret
}

function jsonToHump(data) {
  return deepClone(data, underline2Hump)
}

function jsonToUnderline(data) {
  return deepClone(data, hump2Underline)
}

// 清理 payload 的空字段，包括空字符串、只包含空格的字符串、空数组、空对象、undefiend
function clearPayload(payload) {
  if (!checkType(payload, 'object')) {
    return payload
  }
  const ret = {}
  //eslint-disable-next-line
  for (let k in payload) {
    let v = payload[k]
    if (checkType(v, 'object')) {
      v = clearPayload(v)
      if (Object.keys(v).length) {
        ret[k] = v
      }
    } else if (checkType(v, 'array')) {
      if (v.length) {
        ret[k] = v
      }
    } else if (checkType(v, 'string')) {
      if (v.replace(/^ +| +$/g, '').length) {
        ret[k] = v
      }
    } else if (v === undefined) {
      // keep
    } else {
      ret[k] = v
    }
  }

  return ret
}

export default {
  hump: jsonToHump,
  underline: jsonToUnderline,
  clearPayload,
  checkType,
}
